module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point3_1-3b23e7ecb35f6222ef7ac410de9498fd.jpg";